'use client';
import styled from 'styled-components';

export const StyledPillText = styled.p`
  ${({ theme, size }) => theme.typography[size === 'small' ? 'label' : 'body']}
  ${({ theme }) => theme.fontFamily.condensed}
  ${({ theme, variant }) => theme.getContrastColors(variant)}
  padding: ${({ theme, size }) => {
    switch (size) {
      case 'small':
        return theme.spacing(3, 2, 3);
      case 'xLarge':
        return theme.spacing(4, 8);
      default:
        return theme.spacing(0.6, 4, 1);
    }
  }};
  height: ${({ size }) => (size === 'small' ? '16px' : '30px')};
  border-radius: 500px;
  text-transform: uppercase;
  width: max-content;
  justify-content: center;
  align-items: center;
  display: inline-flex;
`;
